import React from "react";
import { Factory, Settings, Users } from "lucide-react";
import AnimatedSection from "../common/AnimatedSection";

const stats = [
  {
    label: "Factory Direct",
    value: "10,000+",
    suffix: "sq. ft",
    icon: Factory,
  },
  {
    label: "Biesse Machines",
    value: "German",
    suffix: "Precision",
    icon: Settings,
  },
  {
    label: "Dedicated Teams",
    value: "4",
    suffix: "Departments",
    icon: Users,
  },
];

export default function StatsBar() {
  return (
    <section className="bg-brand-primary py-8">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-3 gap-4 md:gap-12">
          {stats.map((stat, index) => {
            const IconComponent = stat.icon;
            return (
              <AnimatedSection
                key={stat.label}
                delay={index * 100}
                className={`flex flex-col md:flex-row items-center md:items-start text-center md:text-left gap-2 md:gap-6 ${
                  index < stats.length - 1
                    ? "md:border-r md:border-brand-accent/30 md:pr-12"
                    : ""
                }`}
              >
                <div className="w-12 h-12 md:w-16 md:h-16 bg-brand-accent/20 rounded-2xl flex items-center justify-center flex-shrink-0 border border-brand-accent/40 shadow-soft">
                  <IconComponent className="w-6 h-6 md:w-8 md:h-8 text-brand-accent" />
                </div>
                <div className="flex-1">
                  <div className="flex flex-col md:flex-row md:items-baseline md:gap-2 mb-1 md:mb-2">
                    <span className="text-lg md:text-2xl font-heading text-brand-accent leading-none">
                      {stat.value}
                    </span>
                    <span className="text-lg md:text-2xl font-heading text-brand-accent leading-none">
                      {stat.suffix}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-white/90 font-medium tracking-wide">
                    {stat.label}
                  </p>
                </div>
              </AnimatedSection>
            );
          })}
        </div>
      </div>
    </section>
  );
}
